<template>
  <div class="loader__wrapp">
    <div class="loader">
      <span /><span /><span /><span />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Loader'
  }
</script>

<style lang="scss">
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &__wrapp {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: $c-white;
  }

  span {
    width: 12px;
    height: 17px;
    background: $c-orange;
    margin: 0px 2px;
    display: inline-block;
    vertical-align: middle;
    animation-name: lodering;
    animation-duration: 450ms;
    animation-iteration-count: infinite;
    animation-direction: alternate;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
    &:nth-child(4) {
      animation-delay: 0.6s;
    }
  }
}

 @keyframes lodering {
  0% {
      height: 17px;
  }
  100% {
      height: 38px;
  }
 }
</style>
